import { render } from "./Moldure.vue?vue&type=template&id=27181619&scoped=true&ts=true"
import script from "./Moldure.vue?vue&type=script&lang=ts"
export * from "./Moldure.vue?vue&type=script&lang=ts"

import "./Moldure.vue?vue&type=style&index=0&id=27181619&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27181619"]])

export default __exports__